import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import logo from "../img/logo.png";

export default function LabsHeader({ back = false, children }) {
  const location = useLocation();
  return <Header>
    <Brand>
      <Link to="/main" aria-label="로우로우 메인"><img src={logo} alt="Lawlow" /></Link>
      {back ? <Link to={{ pathname: "/lab", search: location.search }} className="labs">랩스 목록</Link> : <span className="labs">랩스</span>}
    </Brand>
    {children || <MainLink to="/main">판례 찾기 <span aria-hidden="true">↗</span></MainLink>}
  </Header>;
}

const Header = styled.header`
  max-width: 1160px; margin: 0 auto; padding: max(24px, env(safe-area-inset-top)) 24px 24px;
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  box-sizing: border-box;
  button { background: transparent; border: 1px solid #dce2de; border-radius: 24px; padding: 10px 14px; font: inherit; font-size: 12px; color: inherit; min-height: 44px; }
  a:focus-visible { outline: 2px solid #008a4c; outline-offset: 4px; border-radius: 4px; }
  @media (max-width: 599px) { padding: max(16px, env(safe-area-inset-top)) 20px 16px; }
`;
const Brand = styled.div`
  display: flex; align-items: center; gap: 16px;
  a { display: inline-flex; align-items: center; min-height: 44px; text-decoration: none; color: inherit; }
  img { display: block; width: 124px; height: auto; }
  .labs { border-left: 1px solid #dfe4e1; padding-left: 16px; font-size: 14px; font-weight: 650; }
  @media (max-width: 599px) { gap: 12px; img { width: 104px; } .labs { padding-left: 12px; font-size: 13px; } }
`;
const MainLink = styled(Link)`display: inline-flex; align-items: center; gap: 8px; min-height: 44px; color: #424a46; font-size: 13px; text-decoration: none; white-space: nowrap;`;
